import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';

import { sendResetPwEmail } from '../../../UtilsEmail';

import { Form, FloatingLabel } from '../../../components/form';
import { Button } from '../../../components/general';

import { URL } from '../../../constants';
import { isEmpty } from '../../../utils';

import { validateSendResetPasswordForm } from './validations';

interface Props {
  email?: string;
  mainBtnText: string;
  hasReturnHomeBtn?: boolean;
}

const SendResentPwEmailComponent: React.FC<Props> = (props) => {
  const { email, mainBtnText, hasReturnHomeBtn } = props;

  const [forgotPwEmail, setForgotPwEmail] = useState('');
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [isSending, setIsSending] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    setForgotPwEmail(email ?? '');
  }, [email]);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForgotPwEmail(e.target.value);
    setErrors({});
  };

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const errors = await validateSendResetPasswordForm({ forgotPwEmail });

    if (!isEmpty(errors)) {
      setErrors(errors);
      return;
    }

    setIsSending(true);

    const isSuccess = await sendResetPwEmail(forgotPwEmail);
    if (isSuccess) navigate(URL.FORGOT_PASSWORD);

    setIsSending(false);
  };

  return (
    <Form onSubmit={onSubmit} disabled={isSending} formClassName="w-full">
      <FloatingLabel
        label="Email"
        name="forgotPwEmail"
        value={forgotPwEmail}
        onChange={onChange}
        isInvalid={!!errors.forgotPwEmail}
        errMsg={errors.forgotPwEmail}
        required
      />

      <div className="w-full flex flex-col sm:flex-row items-center justify-between gap-4">
        <Button
          className={classNames('w-full', {
            'sm:w-1/2': hasReturnHomeBtn,
            'sm:w-full': !hasReturnHomeBtn,
          })}
          isSubmitBtn
          isProcessing={isSending}
        >
          {mainBtnText}
        </Button>

        {hasReturnHomeBtn && (
          <Button
            colour="pink"
            className="w-full sm:w-1/2"
            onClick={() => navigate(URL.HOME)}
          >
            Return Home
          </Button>
        )}
      </div>
    </Form>
  );
};

export default SendResentPwEmailComponent;
